import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { useProducts } from "@/context/ProductsContext";
import { CATEGORIES, IMG } from "@/data/mockData";
import SectionHeading from "@/components/SectionHeading";
import { ArrowUpRight } from "lucide-react";

export default function Collections() {
  const { products } = useProducts();
  const pickImageFor = (slug) => {
    const match = products.find((p) => p.category === slug);
    return match ? match.image : IMG.necklace1;
  };
  return (
    <div data-testid="page-collections" className="pt-32 pb-24">
      <Seo path="/collections" title="Silver Collections" description="Browse 18 curated silver collections — bridal, festive, daily, pooja, gifting and more — from SIRIJA, Pune." />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="overline">Collections</div>
          <h1 className="mt-6 font-serif font-light text-5xl lg:text-7xl leading-[1] tracking-tight">
            Eighteen edits. <span className="italic silver-shimmer">One quiet metal.</span>
          </h1>
          <p className="mt-6 text-[15px] text-[#2E2E2E]/75 max-w-xl font-light">
            From bridal to everyday, from pooja to gifting — browse the SIRIJA library, each a considered edit of our best silver.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
          {CATEGORIES.map((c, i) => (
            <Link
              key={c.slug}
              to="/shop"
              data-testid={`collection-card-${c.slug}`}
              className="group relative block aspect-square rounded-2xl overflow-hidden bg-[#F8F9FA]"
            >
              <img
                src={pickImageFor(c.slug)}
                alt={c.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute inset-x-4 bottom-4 flex items-end justify-between text-white">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.24em] opacity-80">Edit {String(i + 1).padStart(2, "0")}</div>
                  <div className="font-serif text-xl lg:text-2xl leading-tight mt-1">{c.name}</div>
                </div>
                <div className="h-9 w-9 rounded-full bg-white/15 backdrop-blur-md flex items-center justify-center group-hover:bg-white group-hover:text-[#1A1A1A] transition-colors">
                  <ArrowUpRight className="h-4 w-4" strokeWidth={1.75} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <section className="mt-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading overline="Signature" title="The Vivaha bridal capsule." sub="A complete silver ensemble — necklace, earrings, maang tikka and bangles — designed to be handed down." />
          <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden"><img src={IMG.bride} alt="Bridal" className="w-full h-full object-cover" /></div>
            <div className="grid grid-cols-2 gap-6">
              <div className="aspect-square rounded-2xl overflow-hidden"><img src={IMG.necklace1} alt="Necklace" className="w-full h-full object-cover" /></div>
              <div className="aspect-square rounded-2xl overflow-hidden"><img src={IMG.bangles1} alt="Bangles" className="w-full h-full object-cover" /></div>
              <div className="aspect-square rounded-2xl overflow-hidden"><img src={IMG.earring1} alt="Earrings" className="w-full h-full object-cover" /></div>
              <div className="aspect-square rounded-2xl overflow-hidden"><img src={IMG.ring1} alt="Ring" className="w-full h-full object-cover" /></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
